import { FillInTableError } from "../fillInTableError";

// classificationManual 등 분류 정보가 없어 Fill In Table을 구성할 수 없는 경우.
// 페이지 크래시 대신 FillInTableErrorBoundary 에서 graceful 하게 처리한다.
export class ClassificationNotDefinedError extends FillInTableError {
  constructor(message = "Classification is not defined") {
    super(message);
  }
}
